import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedRound: null, // Initially no round is selected
  rounds: [], // Array to hold the rounds fetched from the API
  backgroundColor: '',
  fontColor:'',
  teamNames: [],
  team1bgColor: '',
  team2bgColor: '',
  buttonColor: '',
  fontfamily:'',
  backgroundImg :'',
  playing: true,
  audio: null, 
  gameName:'',
  code: null,
  isMobile: true,
  };
const initialAudioState = {
  progress: 0,  // Percentage of music completed
  volume: 10, 
  loop: false ,
};

const audioSlice = createSlice({
  name: 'audio',
  initialState: initialAudioState,
  reducers: {
    setProgress: (state, action) => {
      state.progress = action.payload;
    },
    setVolume: (state, action) => {
      state.volume = action.payload;
    },
    setPlaying: (state, action) => {
      state.playing = action.payload;
    },
    setAudio: (state, action) => {
      state.audio = action.payload || 50;
    },
    setLoop: (state, action) => {
      state.loop = action.payload;  // New reducer to handle looping
    },
  },
});


const roundSlice = createSlice({
  name: 'round',
  initialState,
  reducers: {
    setRounds: (state, action) => {
      state.rounds = action.payload;
    },
    setSelectedRound: (state, action) => {
      state.selectedRound = action.payload;
    },
    resetSelectedRound: (state) => {
      state.selectedRound = null;
    }
  }
});

const backgroundColorSlice = createSlice({
  name: 'backgroundColor',
  initialState,
  reducers: {
    setbackgroundColor: (state, action) => {
      state.backgroundColor = action.payload; // Correctly update the state
    },
  },
});
const backgroundImgSlice = createSlice({
  name: 'backgroundImg',
  initialState,
  reducers: {
    setbackgroundImg: (state, action) => {
      state.backgroundImg = action.payload; // Correctly update the state
    },
  },
});
const logoSlice = createSlice({
  name: 'logo',
  initialState,
  reducers: {
    setlogo: (state, action) => {
      state.logo = action.payload; // Correctly update the state
    },
  },
});
const gameNameSlice = createSlice({
  name: 'gameName',
  initialState,
  reducers: {
    setgameName: (state, action) => {
      state.gameName = action.payload; // Correctly update the state
    },
  },
});
const FontColorSlice = createSlice({
  name: 'fontColor',
  initialState,
  reducers: {
    setfontColor: (state, action) => {
      state.fontColor = action.payload; // Correctly update the state
    },
  },
});
const gameSettingsSlice = createSlice({
  name: 'gameSettings',
  initialState,
  reducers: {
    setTeamNames: (state, action) => {
      state.teamNames = action.payload;
    },
    setTeam1bgColor: (state, action) => {
      state.team1bgColor = action.payload;
    },
    setTeam2bgColor: (state, action) => {
      state.team2bgColor = action.payload;
    },
    setButtonColor: (state, action) => {
      state.buttonColor = action.payload;
    },
    setfontfamily: (state, action) => {
      state.fontfamily = action.payload;
    },
  },
});

const codeSlice = createSlice({
  name: 'code',
  initialState,
  reducers: {
    setCode: (state, action) => {
      state.code = action.payload;
    },
  },
});

const mobileSlice = createSlice({
  name: 'mobile',
  initialState,
  reducers: {
    setIsMobile: (state, action) => {
      state.isMobile = action.payload; // Action to set isMobile
    },
  },
});

const localizationSlice = createSlice({
  name: "localization",
  initialState,
  reducers: {
    setlocalization: (state, action) => {
      state.localization= action.payload; // Correctly update the state
    },
  },
});
export const { setlocalization } =localizationSlice.actions;
export const localizationReducer = localizationSlice.reducer;

const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    setlanguage: (state, action) => {
      state.language= action.payload; // Correctly update the state
    },
  },
});
export const { setlanguage } = languageSlice.actions;
export const languageReducer = languageSlice.reducer;

export const { setCode } = codeSlice.actions;
export const codeReducer = codeSlice.reducer;

export const { setRounds, setSelectedRound, resetSelectedRound } = roundSlice.actions;
export const roundReducer = roundSlice.reducer;

export const { setbackgroundColor } = backgroundColorSlice.actions;
export const backgroundColorReducer = backgroundColorSlice.reducer;

export const { setbackgroundImg } = backgroundImgSlice.actions;
export const backgroundImgReducer = backgroundImgSlice.reducer;

export const { setlogo } = logoSlice.actions;
export const logoReducer = logoSlice.reducer;

export const { setgameName } = gameNameSlice.actions;
export const gameNameReducer = gameNameSlice.reducer;

export const { setfontColor } = FontColorSlice.actions;
export const FontColorReducer = FontColorSlice.reducer;

export const {
  setTeamNames,
  setTeam1bgColor,
  setTeam2bgColor,
  setButtonColor,
  setfontfamily,
} = gameSettingsSlice.actions;

export const gameSettingsReducer = gameSettingsSlice.reducer;

export const { setProgress,setVolume,setPlaying,setAudio ,setLoop    } = audioSlice.actions;
export const audioReducer = audioSlice.reducer;

export const { setIsMobile } = mobileSlice.actions;
export const mobileReducer = mobileSlice.reducer;